
import { defineComponent, inject, ref } from 'vue'
import FavoriteButton from '@/components/Form/FavoriteButton.vue'
import ModeButton from '@/components/Page/ModeButton.vue'

export default defineComponent({
  name: 'PageHeader',
  components: {
    FavoriteButton,
    ModeButton
  },
  setup() {
    const emitter: any = inject('emitter')
    let menuVisible = ref(false)

    const onClick = () => {
      menuVisible.value = !menuVisible.value
      emitter.emit('hideDialogs')
      emitter.emit('hideOverlay')
      if (menuVisible.value) {
        document.body.classList.add('is-fixed')
      } else {
        document.body.classList.remove('is-fixed')
      }
    }

    return {
      menuVisible,
      onClick
    }
  }
})
